export default "__VITE_ASSET__BnzI7EIB__"